import type { LineCitation } from '../../services/ai/citations/citationTypes'
import { LINE_CITATION_ICON } from '../../services/ai/citations/citationTypes'
import { BottomSheet } from '../Common/BottomSheet'
import { Button } from '../Common'
import { useNls } from '../../nls/nlsProvider'

/**
 * Mobile bottom-sheet excerpt viewer. Uses Common BottomSheet.
 */
export const CitationExcerptSheet = ({
  id,
  isOpen = true,
  citation,
  onClose,
  onOpenSource,
}: {
  id?: string
  isOpen?: boolean
  citation: LineCitation
  onClose: () => void
  onOpenSource: () => void
}) => {
  const { t } = useNls()
  const Icon = LINE_CITATION_ICON[citation.sourceKind]

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={citation.title}>
      <div id={id} className="lineCiteSheet__body">
        <header className="lineCiteSheet__header" style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
          <span aria-hidden="true" style={{ fontSize: 20 }}><Icon fontSize="inherit" /></span>
          <div style={{ fontSize: 11, textTransform: 'uppercase', opacity: 0.6, letterSpacing: 0.4 }}>
            {citation.sourceKind.replace(/_/g, ' ')}
          </div>
        </header>
        <blockquote style={{ margin: '12px 0', paddingLeft: 12, borderLeft: '3px solid var(--border)', fontSize: 14, lineHeight: 1.45 }}>
          {citation.excerpt}
        </blockquote>
        <Button
          variant="primary"
          fullWidth
          onClick={onOpenSource}
        >
          {t('NLSAiCitationOpenSource')}
        </Button>
      </div>
    </BottomSheet>
  )
}
